class ScrollTide {
  constructor({nomarkers}) {
    //console.log("contructing!")
    this.nomarkers = nomarkers
    this.scrollY = window.scrollY
    this.started = false
    this._docHeight = document.documentElement.scrollHeight
  }
  add(scroller) {
    // console.log("adding sroller")
    // console.log(scroller)
    this.scrollers.push(scroller)

    if (scroller.markers && this.nomarkers == false){
      scroller.setup_markers(this.scrollers.length)
    }
  }
  start(){

    //do it once to get the pre-scrolled state correct
    var scrollY = window.scrollY


    for (const scroller of this.scrollers){
      scroller.recache()
      scroller.do_scroll_anims(scrollY)
    }

    this.scrollY = scrollY
    this._docHeight = document.documentElement.scrollHeight
        


    // //do it on scroll
    // window.onscroll = () => {
      
    //   //this.scrollY = window.scrollY
    //   // console.log("scroll")
    //   // const scrollY = window.scrollY

    //   // for (const scroller of this.scrollers)
    //   //   scroller.do_scroll_anims(scrollY)

    // };

    // // //do it on window resize
    // window.onresize = () => {
      
    //   //this.scrollY = window.scrollY

    // }
    
    
    if (!this.started) {
      requestAnimationFrame(this.tick)
      this.started = true
      var self = this
      window.addEventListener("resize", function(){
        self.update()
      })
    }
    
  }
  update(){
    this.scrollY = window.scrollY
    for (const scroller of this.scrollers){
      scroller.recache()
      scroller.do_scroll_anims(this.scrollY)
    }
    this._docHeight = document.documentElement.scrollHeight
  }
  tick(){

    // Lazy images / fonts above a tied section change document height
    // and shift trigger points. Recache when that happens so animations
    // stay locked to the live layout instead of the first-paint cache.
    var h = document.documentElement.scrollHeight
    if (h !== scrolltied._docHeight) {
      scrolltied._docHeight = h
      for (const scroller of scrolltied.scrollers)
        scroller.recache()
    }

    for (const scroller of scrolltied.scrollers)
      scroller.do_scroll_anims(scrolltied.scrollY)

    requestAnimationFrame(scrolltied.tick)
  }
  stop(){

  }
  remove(id){
    //remove it?
    for (var i = 0; i < this.scrollers.length; i++){
      if (this.scrollers[i].id == id){
        this.scrollers[i].destroy()
        this.scrollers.splice(i,1)
        return;
      }
    }
  }
  remove_all(){
    for (var i = 0; i < this.scrollers.length; i++){
      this.scrollers[i].destroy()
      delete this.scrollers[i]
    }
    this.scrollers = []
  }
  scrollers = [] //internal property containing all Scroller instances
}


class Scroller{

  constructor({id, container, window_offset, el_start, el_end, progress_max, anime, classes, stick_class, targets, onprogress, onunstart, onbefore, oncomplete, onstart, markers} = {}) {

    this.id = id
    this.container = container
    this.window_offset = window_offset
    this.el_start = el_start
    this.el_end = el_end 
    this.progress_max = progress_max !== undefined ? progress_max : 100
    this.anime = anime
    this.markers = markers
    this.onbefore = onbefore
    this.onstart = onstart
    this.onunstart = onunstart
    this.onprogress = onprogress
    this.oncomplete = oncomplete
    this.classes = classes
    this.stick_class = stick_class

    this.didEverStart = false
    this.state = "before"

    this.targets = targets

    this.els_to_cleanup = []
    this.cache = {
      window: {
        innerHeight: window.innerHeight
      },
      el:{
        offsetTop:container.offsetTop,
        scrollHeight:container.scrollHeight
      }
    }

    this.y_marker_pos = window.innerHeight * window_offset
    
    return 
  }
  recache(){
    this.cache = {
      window: {
        innerHeight: window.innerHeight
      },
      el:{
        offsetTop:this.container.offsetTop,
        scrollHeight:this.container.scrollHeight
      }
    }
  }
  percent_through_el(window_offset, el_start, el_end, scrollY){
    var window_y_marker = (this.cache.window.innerHeight * window_offset) + scrollY;
  
    var el_y_start = this.cache.el.offsetTop + (this.cache.el.scrollHeight * el_start)
    var el_y_end = this.cache.el.offsetTop + (this.cache.el.scrollHeight * el_end)
  
    var travel_distance = el_y_end - el_y_start
    var distance_through = window_y_marker - el_y_start
  
    
    if (distance_through < 0){
      return 0
    }
    return (distance_through / travel_distance)*100
    
    //console.log(distance_through)
  
    
  }


  do_scroll_anims(scrollY){
    
    let percent_through = this.percent_through_el(this.window_offset,this.el_start,this.el_end, scrollY)
    
    // if (this.id == "stage-2"){
    //   console.log(this.didEverStart)
    // }

    if (percent_through >= this.progress_max){

      // Skip-ahead (refresh / restore / fast scroll): fire start then complete
      // so the animation lands on its finished state instead of getting stuck
      if (this.state !== "past") {
        if (this.state === "before" && this.onstart) {
          this.onstart()
        }
        if (this.oncomplete) {
          this.oncomplete()
        }
      }

      this.didEverStart = true
      this.state = "past";
    }
    else if (percent_through <= 0){
      
      if (this.state != "before" && this.onunstart && this.didEverStart){
        this.onunstart()
      }
      
      this.didEverStart = false
      this.state = "before";
    }
    else {
      
      if (this.state == "before" && this.onstart){
        this.onstart()
      }

      this.didEverStart = true
        
      this.state = "during";
    }


    if (this.state == "before"){
      if (this.classes) {
        for (var target of this.targets){
          target.classList.remove(...this.classes)
        }
      }
    }

    if (this.state == "during" && this.onprogress){
      this.onprogress(percent_through)
    }



    if (this.classes) {
      if (this.state == "past" && this.stick_class == false){
        for (var target of this.targets){
          target.classList.remove(...this.classes)
        }
      }
      else if (this.state == "past") {
        for (var target of this.targets){
          target.classList.add(...this.classes)
        }
      }
      if (this.state == "during"){
        for (var target of this.targets){
          target.classList.add(...this.classes)
        }
      }
    }





    if (this.marker_bar) {
      if (this.state == "during") {
        this.marker_bar.style.width = "6px"
        this.marker_bar.style.opacity = "1"
        this.marker_label.style.opacity = "1"
      } else {
        this.marker_bar.style.width = "2px"
        this.marker_bar.style.opacity = "0.3"
        this.marker_label.style.opacity = "0.3"
      }
    }

    if (this.anime){
      this.anime.seek(percent_through)
    }
      
  
  }

  setup_markers(index){

    var colors = ["red","orange","green","blue","violet"]
    var position = ["0","4", "8", "12", "16"]
    var mod = index % 5;

    let threshold_marker = document.createElement("div")
    threshold_marker.classList.add("threshold_marker")
    threshold_marker.style.top = this.el_start *100 + "%"
    let height = (this.el_end - this.el_start) * 100
    threshold_marker.style.height = height + "%"
    threshold_marker.style.position = "absolute"
    threshold_marker.style.width = "2px"
    threshold_marker.style.right = position[mod] + "px"
    threshold_marker.style.zIndex = "1000000"
    threshold_marker.style.backgroundColor = colors[mod]
    threshold_marker.style.opacity = "0.3"
    threshold_marker.style.transition = "width 0.2s ease, opacity 0.2s ease"


    let threshold_label = document.createElement("span")
    threshold_label.classList.add("threshold_label")
    threshold_label.style.top = "calc(" + this.el_start *100 + "% - 12px)"
    threshold_label.innerText = this.id
    threshold_label.style.position = "absolute"
    threshold_label.style.right = "6px"
    threshold_label.style.color = "black"
    threshold_label.style.zIndex = "10000"
    threshold_label.style.fontSize = "10px"
    threshold_label.style.opacity = "0.3"
    threshold_label.style.transition = "opacity 0.2s ease"



    let trigger_marker = document.createElement("div")
    trigger_marker.classList.add("trigger_marker")
    trigger_marker.style.top = "calc(" + this.window_offset * 100 + "% - 2px)"
    trigger_marker.style.position = "fixed"
    trigger_marker.style.right = "0"
    trigger_marker.style.width = "20px"
    trigger_marker.style.height = "4px"
    trigger_marker.style.background = "lawngreen"
    trigger_marker.style.zIndex = "10000"


    if (this.anime && this.anime.animations[0].tweens.length > 1){
      console.log("Need keyframes!")

      var cum_duration = 0
      for (var tween of this.anime.animations[0].tweens){
        let keyframe_marker = document.createElement("div")
        keyframe_marker.classList.add("keyframe_marker")
        keyframe_marker.style.top = tween.delay + cum_duration + "%"
        let height = (tween.duration - tween.delay) + "%"
        keyframe_marker.style.height = height

        cum_duration += tween.duration

        threshold_marker.appendChild(keyframe_marker);
      }
    }


    this.marker_bar = threshold_marker;
    this.marker_label = threshold_label;

    this.els_to_cleanup.push(threshold_marker);
    this.els_to_cleanup.push(trigger_marker);
    this.els_to_cleanup.push(threshold_label);

    this.container.appendChild(threshold_marker);
    this.container.appendChild(trigger_marker);
    this.container.appendChild(threshold_label);

    //do keyframe markers

  }
  destroy(){
    for (var el of this.els_to_cleanup){
      el.remove()
    }
  }

}




function runLoop(callback) {
    const fps = 45;
    const interval = 1000 / fps;
    let lastTime = 0;

    function loop(currentTime) {
        if (currentTime - lastTime >= interval) {
            callback();
            lastTime = currentTime;
        }
        requestAnimationFrame(loop);
    }

    requestAnimationFrame(loop);
}

// Example usage:
runLoop(() => {
  if (!window.scrolltied) return

  window.scrolltied.scrollY = window.scrollY
});

